import React from 'react'
import {
  IconTile,
  ListTile,
  ListTileItem,
  TitleContainer,
} from '../../'

const ConfigurationRoot = (props) => {
  const {
    handleClick,
    configurations,
    parentSelection,
  } = props

  const maxReached = (
    Array.isArray(parentSelection.selection)
    && (parentSelection.maxSelect > 1)
    && (parentSelection.selection.length >= parentSelection.maxSelect)
  )

  return (
    <TitleContainer
      title="Konfiguration"
    >
      <ListTile>
        {configurations && configurations.map((configuration, index) => (
          <ListTileItem
            key={`configuration-${configuration.id}`}
            index={index}
            length={configurations.length}
          >
            <IconTile
              disabled={(maxReached && !parentSelection.selection.includes(configuration.id))}
              handleClick={() => handleClick(configuration.id)}
              index={index}
              isSelected={parentSelection.selection.includes(configuration.id)}
              node={configuration}
            />
          </ListTileItem>
        ))}
      </ListTile>
    </TitleContainer>
  )
}

export default ConfigurationRoot



// WEBPACK FOOTER //
// ./src/modules/configuration/components/configurationRoot.jsx